/** Grymwyrd русский текст главной страницы. */
export const homeRu = {
  'home.heroEyebrow': 'Живой мир ужасов и фэнтези',
  'home.heroTitle': 'Вступи в Сумрак',
  'home.heroBody':
    'Grymwyrd — это захваченный миром викторианского готического ужаса, где утонувший в тумане город Greywick скрывает разрушенные башни, подземелья усадеб и обряды, о которых лучше не говорить. Создай героя, приподними завесы Катаклизма и высеки своё имя в мире, который помнит.',
  'home.heroPlayCta': 'Играть',
  'home.heroBrowseCta': 'Проверить Энциклопедию',
  'home.heroQuickstartPrompt': 'Не готов к игре? Получи бесплатный Quickstart',
}
